import React, {memo} from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import {Card, CardBody} from 'components/card';
import LazyImage from 'helpers/LazyImage';
import {replaceAssetsImgUrl} from 'cms/helpers/common';

const settings = (initSlide) => ({
  className: 'mb-4',
  dots: false,
  initialSlide: initSlide,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 5,
  arrows: false,
  responsive: [{
    breakpoint: 1000,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 800,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});

const CategoryCard = ({initSlide, posts}) => (
  <Slider {...settings(initSlide)}>
    {
      posts.map(({ID, post_title, post_date_gmt, post_excerpt, permanlink, image}) => (
        <a key={ID} href={permanlink} className="p-2 text-decoration-none">
          <Card key={ID} shadow>
            <LazyImage
              imgClass="card-img-top object-fit-cover"
              src={replaceAssetsImgUrl(image, 400)}
              width="100%"
              height="200"
              title={post_title}
              alt={post_title}
              srcSizes={[400, 340, 290, 210]}
            />
            <CardBody>
              <div className="font-bold max-lines-2"  dangerouslySetInnerHTML={{__html: post_title}} />
              <div className="mb-1 text-muted">{post_date_gmt}</div>
              <div className="max-lines-3" dangerouslySetInnerHTML={{__html: post_excerpt}} />
            </CardBody>
          </Card>
        </a>
      ))
    }
  </Slider>
);

CategoryCard.propTypes = {
  initSlide: PropTypes.number.isRequired,
  posts: PropTypes.array.isRequired
};

CategoryCard.defaultProps = {
  initSlide: 0
};

export default memo(CategoryCard);
